import { render, staticRenderFns } from "./TemplateEditorModal.vue?vue&type=template&id=8261b786&scoped=true&"
import script from "./TemplateEditorModal.vue?vue&type=script&lang=js&"
export * from "./TemplateEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEditorModal.vue?vue&type=style&index=0&id=8261b786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8261b786",
  null
  
)

export default component.exports